module.exports = __webpack_public_path__ + "assets/media/letter.d348cbaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookPickBotStep/letter.svg
// module id = 3123
// module chunks = 0